import './tekst-afbeeldingen-slider.scss';

function initTekstAfbeeldingenSlider() {
	const sliders = document.querySelectorAll( '[data-tekst-afbeeldingen-slider]' );

	if ( ! sliders.length ) {
		return;
	}

	sliders.forEach( ( slider ) => {
		let isDown = false;
		let startX = 0;
		let scrollLeft = 0;

		slider.addEventListener( 'pointerdown', ( event ) => {
			if ( 'mouse' !== event.pointerType ) {
				return;
			}

			isDown = true;
			startX = event.pageX - slider.offsetLeft;
			scrollLeft = slider.scrollLeft;
			slider.classList.add( '-dragging' );
			slider.setPointerCapture( event.pointerId );
		} );

		slider.addEventListener( 'pointermove', ( event ) => {
			if ( ! isDown ) {
				return;
			}

			event.preventDefault();
			const x = event.pageX - slider.offsetLeft;
			slider.scrollLeft = scrollLeft - ( x - startX );
		} );

		function endDrag( event ) {
			if ( ! isDown ) {
				return;
			}

			isDown = false;
			slider.classList.remove( '-dragging' );

			if ( slider.hasPointerCapture( event.pointerId ) ) {
				slider.releasePointerCapture( event.pointerId );
			}
		}

		slider.addEventListener( 'pointerup', endDrag );
		slider.addEventListener( 'pointercancel', endDrag );
		slider.addEventListener( 'pointerleave', endDrag );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initTekstAfbeeldingenSlider );
} else {
	initTekstAfbeeldingenSlider();
}
